import {StrangeConversions} from "./fb-conversions";
import { initBudgetSliders } from "./conversion-mp-budget-slider";
import Cookies from 'js-cookie';
import { FormatPhoneInput } from "./helpers/format-phone-input";

//
// Forms JS
// --------------------------------------------------
// All the functions specifically for usage with freeform forms including:
// Populating hidden form fields
// Validation and formatting of the phone number field
// Sets error and success message position
// Pushes data to datalayer on form submission for GTM

window.addEventListener('load', event => {

    // Function that pushes GA data through to datalayer for GTM
    // ...additional datalayer data can be added at time of form submission
    function gtmPush(event, formId, additional = {}) {
        if (typeof dataLayer !== 'undefined') {
            const strangeEventId = StrangeConversions.generateEventId();

            dataLayer.push({
                ...additional,
                event: event,
                formName: formId,
                strangeEventId: strangeEventId
            });

            return strangeEventId;
        }

        return null;
    }

    function initializeAutocomplete(input) {
        const autocomplete = new google.maps.places.Autocomplete(input);
        autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
    }

    // Function that sets field values based on cookies etc.
    function setFormValues(form) {

        // Array of form fields and the new value that should be assigned to that field
        let formFields = [
            {
                handle: form.utmSource,
                newValue: Cookies.get('utm_source')
            },
            {
                handle: form.utmMedium,
                newValue: Cookies.get('utm_medium')
            },
            {
                handle: form.utmCampaign,
                newValue: Cookies.get('utm_campaign')
            },
            {
                handle: form.utmContent,
                newValue: Cookies.get('utm_content')
            },
            {
                handle: form.gaclientid,
                newValue: Cookies.get('_ga')?.slice(6)
            },
            {
                handle: form.gatrackid,
                newValue: typeof google_tag_manager === 'object' ? Object.keys(google_tag_manager).filter((key) => key.indexOf('G-') === 0) : ''
            },
            {
                handle: form.gclid,
                newValue: Cookies.get('ff_gclid')
            },
            {
                handle: form.pageUrl,
                newValue: window.location
            },
            {
                handle: form.staffFullName,
                newValue: form.dataset.staffName
            },
            {
                handle: form.staffRole,
                newValue: form.dataset.staffRole
            },
            {
                handle: form.staffEmail,
                newValue: form.dataset.staffEmail
            },
            {
                handle: form.staffPhone,
                newValue: form.dataset.staffPhone
            },
            {
                handle: form.staffLinkedIn,
                newValue: form.dataset.staffLinkedin
            },
            {
                handle: form.staffFacebook,
                newValue: form.dataset.staffFacebook
            },
            {
                handle: form.staffInstagram,
                newValue: form.dataset.staffInstagram
            },
        ]

        // Assign form fields new values if they exist
        for (let field of formFields) {
            if (field.handle && field.newValue) {
                field.handle.value = field.newValue;
            }
        }
    }

    // Adds transition classes to notification, fades to 0 opacity and then hides from dom on transition finish
    function fadeOutNotification(form) {
        let notifications = form.querySelectorAll('.ff-form-errors, .ff-form-success');

        for (let notification of notifications) {
            notification.classList.add('transition-opacity', 'duration-500', 'delay-[15000ms]', 'flex', 'items-center');

            setTimeout(() => {
                notification.classList.add('opacity-0');
            }, 50);

            notification.addEventListener('transitionend', event => {
                notification.classList.add('hidden');
            }, { once: true });
        }
    }

    // Freeform functions
    let forms = document.querySelectorAll('form');

    for (let form of forms) {
        const formId = form.id;

        // Override Freeform default error/success message
        // Commented as should be set on form via cms, but could be useful for a dynamic message on a reusable form
        // freeform.setOption('errorBannerMessage', 'Error!');
        // freeform.setOption('successBannerMessage', 'Success!');

        // Run when freeform initialises
        form.addEventListener("freeform-ready", function (event) {
            // Phone Validation for: input[data-validate="mobile"]
            const phoneInput = form.querySelector('input[data-validate="mobile"]');
            const phoneValidationMessage = 'Please provide a valid phone number.';

            initBudgetSliders(form);

            if (phoneInput) {
                phoneInput.addEventListener('change', (event) => {
                    const phoneVal = FormatPhoneInput.formatMobileNumber(phoneInput.value);

                    if (phoneInput.value !== phoneVal) {
                        phoneInput.value = phoneVal;
                    }

                    if (phoneVal.match(/^\+61 4\d{2} \d{3} \d{3}$/)) {
                        // Clear any errors on the input
                        phoneInput.setCustomValidity('');
                        phoneInput.reportValidity();
                    }

                    // no else statement here as we are matching existing validation flow from freeform where the errors only appear when attempting to submit
                });

                form.addEventListener('freeform-on-submit', function (submitEvent) {
                    if (!phoneInput.value.match(/^\+61 4\d{2} \d{3} \d{3}$/)) {
                        phoneInput.setCustomValidity(phoneValidationMessage);
                        phoneInput.reportValidity();

                        submitEvent.preventDefault();
                    }
                    else {
                        phoneInput.setCustomValidity('');
                        phoneInput.reportValidity();
                    }
                });
            }

            if (form.getAttribute('id') === 'email-signature-form') {
                const template = document.querySelector('#email-signature-template');
                if (template) {
                    const defaultBanner = form.dataset.defaultBanner;

                    const bannerSelect = form.querySelector('select[name="banner"]');
                    const dynamicBannerImg = form.querySelector('img[data-dynamic-banner-src]');
                    const avatarSelect = form.querySelector('select[name="avatar"]');
                    const dynamicAvatarImg = form.querySelector('img[data-dynamic-avatar-src]');

                    const customBannerInput = form.querySelector('input[name="bannerCustomUrl"]');
                    const customAvatarInput = form.querySelector('input[name="avatarCustomUrl"]');

                    customBannerInput?.closest('.freeform-row')?.classList.add('hidden');
                    customAvatarInput?.closest('.freeform-row')?.classList.add('hidden');

                    if (bannerSelect && dynamicBannerImg) {
                        dynamicBannerImg.src = defaultBanner;
                        dynamicBannerImg.closest('a').href = defaultBanner;

                        bannerSelect.addEventListener('change', () => {
                            if (bannerSelect.value === 'Custom URL') {
                                customBannerInput?.closest('.freeform-row')?.classList.remove('hidden');
                            } else {
                                customBannerInput?.closest('.freeform-row')?.classList.add('hidden');
                            }
                            if (bannerSelect.value === 'Custom URL' || bannerSelect.value === 'No Banner') {
                                dynamicBannerImg?.closest('a')?.classList.add('hidden')
                            } else {
                                dynamicBannerImg?.closest('a')?.classList.remove('hidden')
                            }
                            if (bannerSelect.value === 'Current Banner') {
                                dynamicBannerImg.src = defaultBanner;
                                dynamicBannerImg.closest('a').href = defaultBanner;
                            } else {
                                dynamicBannerImg.src = bannerSelect.value;
                                dynamicBannerImg.closest('a').href = bannerSelect.value;
                            }
                        });
                    }

                    if (avatarSelect && dynamicAvatarImg) {
                        avatarSelect.addEventListener('change', () => {
                            if (avatarSelect.value === 'Custom URL') {
                                customAvatarInput?.closest('.freeform-row')?.classList.remove('hidden');
                                customAvatarInput?.closest('.freeform-row')?.classList.remove('hidden');
                                dynamicAvatarImg?.closest('a')?.classList.add('hidden')
                            } else {
                                customAvatarInput?.closest('.freeform-row')?.classList.add('hidden');
                                dynamicAvatarImg?.closest('a')?.classList.remove('hidden')
                                customAvatarInput?.closest('.freeform-row')?.classList.add('hidden');
                            }

                            dynamicAvatarImg.src = avatarSelect.value;
                            dynamicAvatarImg.closest('a').href = avatarSelect.value;
                        });
                    }
                }
            }


        });

        // Runs when freeform has attempted a submission
        form.addEventListener('freeform-on-submit', function (event) {

            // Calls function to set dynamic field values
            setFormValues(form);

            if (form.getAttribute('id') === 'email-signature-form') {
                const template = document.querySelector('#email-signature-template');

                if (template) {
                    // Extract the form data
                    const name = form.querySelector('#form-input-name').value;
                    const role = form.querySelector('#form-input-role').value;
                    let phone = form.querySelector('#form-input-phone').value;
                    const address = form.querySelector('#form-input-address').value;
                    let avatarUrl = form.querySelector('#form-input-avatar').value;
                    let avatarCustomUrl = form.querySelector('#form-input-avatarCustomUrl').value;
                    let bannerUrl = form.querySelector('#form-input-banner').value;
                    let bannerCustomUrl = form.querySelector('#form-input-bannerCustomUrl').value;
                    const defaultBannerUrl = form.dataset.defaultBanner;
                    const perthAddressText = form.dataset.perthAddress;
                    const perthAddressUrl = form.dataset.perthUrl;
                    const melbourneAddressText = form.dataset.melbourneAddress;
                    const melbourneAddressUrl = form.dataset.melbourneUrl;
                    const defaultPhoneNumber = form.dataset.defaultPhone;

                    // Determine address text and URL based on the selected address
                    let addressText, addressUrl;
                    if (address === 'Perth') {
                        addressText = perthAddressText;
                        addressUrl = perthAddressUrl;
                    } else {
                        addressText = melbourneAddressText;
                        addressUrl = melbourneAddressUrl;
                    }

                    // Set custom avatar URL if custom URL is provided else fallback to placeholder
                    if (avatarUrl === 'Custom URL' && avatarCustomUrl !== '') {
                        avatarUrl = avatarCustomUrl;
                    } else if (avatarUrl === 'Custom URL' && avatarCustomUrl === '') {
                        avatarUrl = 'https://strangeanimals.s3.ap-southeast-2.amazonaws.com/email/staff/placeholder-animated.gif';
                    }

                    // Set custom banner URL if custom URL is provided else fallback to default
                    if (bannerUrl === 'Custom URL' && bannerCustomUrl !== '') {
                        bannerUrl = bannerCustomUrl;
                    } else if ((bannerUrl === 'Custom URL' && bannerCustomUrl === '') || bannerUrl === 'Current Banner') {
                        bannerUrl = defaultBannerUrl;
                    }

                    // Set a default phone number if none is provided and generate a tel: URL
                    let phoneUrl;
                    if (phone === '' && defaultPhoneNumber) {
                        phone = defaultPhoneNumber;
                        phoneUrl = 'tel:' + defaultPhoneNumber.replace(' ','');
                    } else {
                        phoneUrl = 'tel:' + phone.replace(/\s+/g, '');
                    }

                    // Clone the template content
                    const templateClone = document.querySelector('#email-signature-template').content.cloneNode(true);

                    // Apply the values to the cloned template
                    templateClone.querySelector('[data-form-data="name"]').innerHTML = name;
                    templateClone.querySelector('[data-form-data="role"]').innerHTML = role;
                    templateClone.querySelector('[data-form-data="phone"]').innerHTML = phone;
                    templateClone.querySelector('[data-form-data="phoneUrl1"]').href = phoneUrl;
                    templateClone.querySelector('[data-form-data="phoneUrl2"]').href = phoneUrl;
                    templateClone.querySelector('[data-form-data="address"]').innerHTML = addressText;
                    templateClone.querySelector('[data-form-data="addressUrl"]').href = addressUrl;
                    templateClone.querySelector('[data-form-data="image"]').src = avatarUrl;
                    if (bannerUrl === 'No Banner') {
                        templateClone.querySelectorAll('[data-banner]').forEach((bannerElement) => {
                            bannerElement.remove();
                        });
                    } else {
                        templateClone.querySelector('[data-form-data="banner"]').src = bannerUrl;
                    }

                    // Clear the entire HTML content of the page
                    document.documentElement.innerHTML = '';

                    // Append the cloned template content to the cleared body
                    document.documentElement.appendChild(templateClone);
                }
            }

        });

        // Runs after ajax submit
        form.addEventListener('freeform-ajax-after-submit', function(event) {

            // Override error/success notification position on ajax submission
            const notifications = form.querySelectorAll('.ff-form-errors, .ff-form-success');
            const submitButton = form.querySelector('button[data-freeform-action="submit"]');
            const inputErrors = form.querySelectorAll('.freeform-errors');

            for (let inputError of inputErrors) {
                const listItems = inputError.querySelectorAll('li');
                for (let listItem of listItems) {
                    listItem.innerText = 'Invalid input';
                }
            }

            for (let notification of notifications) {
                submitButton?.closest('.freeform-row')?.appendChild(notification);
                fadeOutNotification(form);
            }

            // scroll to top of section when prev/nexting on multipage forms
            if (form.classList.contains('multipage-freeform-form')) {
                const formSection = form.closest('section');

                if (formSection) {
                    formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }

            initBudgetSliders(form);
        });

        // Runs before ajax submit
        form.addEventListener('freeform-ajax-before-submit', function(event) {

            // Adds any additional requirements to GA data
            // payload = form data after 'freeform-on-submit' has run
            // payload.get('field handle') = associated value of that field handle
            const payload = event.data;

            form.dataLayerSubmission = {
                gaFormName: payload.get('gaformname'),
                formOptionSelected: payload.get('formOptionSelected'),
            };
        });

        // Runs after successful ajax submission
        form.addEventListener('freeform-ajax-success', function(event) {
            // Pushes GA data through to datalayer
            const eventId = gtmPush('formSubmitted', formId, {enquiryFormData: form.dataLayerSubmission});

            if (eventId) {
                StrangeConversions.convertGtmPixelEvent('Contact', eventId, form.conversionData);
            }

            let formContainer = form.closest('div[data-form-complete]');

            if (formContainer) {
                formContainer.dataset.formComplete = 'true';
                setTimeout(() => {
                    formContainer.dataset.formComplete = 'false';
                }, 10000);
            }
        });
    }

    // Fix for the sprig search when navigating back to a page
    const searchInput = document.querySelector('section#searchPanel input');
    if (searchInput && searchInput.value.length) {
        const event = new KeyboardEvent('keyup', { key: 'Enter', code: 'Enter', which: 13, keyCode: 13, });
        searchInput.dispatchEvent(event);
    }
});
